<template>
		<div v-bind:class="['item', 'c-item-'+work.work_id, (work.is_cpromo=='y')?'active-picture':'']" :coverage_uri="getWorkUri(work)"><!-- :href="getWorkUrl(work)" -->
      <works-item-info :work="work"/>

      <div class="zoom-in rel">
        <div class="item-image" v-if="work.storage_id==20">
          <div v-if="is_editable_works" class="item-sub-control item-control-check c_item-control-check" style="z-index: 100">
            <label onclick="stop_bubble(event);return false;">
              <input onclick="action_work.select_work(event);" class="c_select_works_input" name="select_works[]" :value="work.work_id" type="checkbox">
            </label>
          </div>

          <a :href="getWorkUrl(work)" @click="slide_show(work, $event)" :ssuri="getWorkUri(work)" onclick="return false">
            <img :class="is_mark_work_pro?getWorkClass(work):''" class="lazyload" :data-src="getWorkSrc(work, 'ox400')"/>
            <works-item-controls v-show="is_show_controls()" :work="work" ></works-item-controls>
          </a>
          <!--<div class="item-cover"
               v-bind:style="{ 'background-image': 'url('+ getWorkSrc(work, 'ox400') +')'}">
          </div>-->
          <!--<works-item-controls v-show="is_show_controls()" :work="work" ></works-item-controls>-->
        </div>
        <div class="item-image" v-if="work.storage_id==0">
          <a :href="getWorkUrl(work)" @click="slide_show(work, $event)" :ssuri="getWorkUri(work)" onclick="return false">
            <img :class="is_mark_work_pro?getWorkClass(work):''" src="/res/img/page-bg/texture-01.jpg"/>
            <works-item-controls v-show="is_show_controls()" :work="work" ></works-item-controls>
          </a>
          <!--<div class="item-cover"  v-bind:style="{ 'background-image': 'url(/res/img/page-bg/texture-01.jpg)'}"></div>-->
          <!--<works-item-controls v-show="is_show_controls()" :work="work" ></works-item-controls>-->
        </div>
        <works-item-cost v-if="is_show_cost(work)" :work="work"/>
      </div>
      <div class="item-info">
        <a :href="getWorkUrl(work)" class="item-title">{{workName}}</a>
        <div v-if="is_show_artist(authorId)" class="item-author">
          <a v-if="works_without_artist" class="c_artist_popup_link" :data-objectid="'artist_'+authorId" :href="getArtistWorksUrl(work)">{{authorName}}</a>
          <span v-if="!works_without_artist">{{authorName}}</span>
        </div>

        <div class="item-size" v-if="(work.sx>0 && work.sy>0) || getWorkYear(work).length>0">
          <span v-if="work.sx>0 && work.sy>0">{{show_num(work.sy/10)}}×{{show_num(work.sx/10)}} {{ $t("message.sm") }}</span><span v-if="work.sx>0 && work.sy>0 && getWorkYear(work).length>0">, </span>
          <span v-if="getWorkYear(work).length>0">{{getWorkYear(work)}}</span>
        </div>
      </div>
		</div>
</template>

<script>
  import WorksItemControls from "./WorksItemControls";
  import WorksItemCost from "./WorksItemCost";
  import WorksItemInfo from "./WorksItemInfo";
  import WorksItemMix from "./WorksItemMix";

  export default {
    mixins: [WorksItemMix],
    components: {
      WorksItemControls,
      WorksItemCost,
      WorksItemInfo,
    },
    name      : 'works-item',
  }
</script>



// WEBPACK FOOTER //
// src/components/list/WorksItem.vue